<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
<div *ngIf="pageLoading1" class="loader text-center">
	<img src="../assets/img/loading.gif" />
</div>
@if(appt){
<div class="row g-1">
	<div class="col-6">
		<div class="card">
			<div class="card-header bg-theme">
				<h5 class="card-title mb-0 p-0 fw-bold">
					Reference No.: {{appt?.ref_no}}
				</h5>
			</div>
			<div class="card-body px-1 pt-1 pb-2">
				<div class="row g-1">
					<div class="col">
						<div class="input-group input-group-sm">
							<label class="input-group-text">
								<app-gender-icon [gender]="appt?.gender"></app-gender-icon>
							</label>
							<input class="form-control" [value]="appt?.Name" [attr.readonly]="true" />
						</div>
					</div>
					<div class="col">
						<div class="input-group input-group-sm">
							<label class="input-group-text text-primary">
								<fa-icon [icon]="['fas','building']" matTooltip="Company"></fa-icon>
							</label>
							<input class="form-control" [value]="appt?.company" [attr.readonly]="true" />
						</div>
					</div>
				</div>
				<div class="row g-1">
					<div class="col">
						<div class="input-group input-group-sm">
							<label class="input-group-text text-danger">
								<fa-icon [icon]="['fas','star']" matTooltip="Rank"></fa-icon>
							</label>
							<input class="form-control" [value]="appt?.rank" [attr.readonly]="true" />
						</div>
					</div>
					<div class="col">
						<div class="input-group input-group-sm">
							<label class="input-group-text text-success">
								<fa-icon [icon]="['fas','calendar']" matTooltip="Date"></fa-icon>
							</label>
							<input class="form-control" [value]="formatDate(appt?.doe)" [attr.readonly]="true" />
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col">
						<table class="table table-bordered table-hover table-striped queans-table my-1">
							<thead>
								<tr>
									<th>Scale</th>
									<th>Score</th>
								</tr>
							</thead>
							<tbody>
								@for (item of appt?.scale_score; track $index) {
								<tr>
									<td>
										{{item.scale}}
									</td>
									<td>
										{{item.score}}
									</td>
								</tr>
								}
							</tbody>
						</table>
					</div>
				</div>
				<div class="row">
					<div class="col">
						<a class="btn btn-sm btn-outline-dark ms-1"
							[routerLink]="['/app/edit-appointment',appt?.ref_no]">
							Back
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="col-6">
		<div class="card">
			<div class="card-header bg-theme">
				<h5 class="card-title mb-0 p-0 fw-bold">
					Report
				</h5>
			</div>
			<div class="card-body px-1 pt-1 pb-2">
				<div class="row">
					<div class="col"></div>
				</div>
			</div>
		</div>
	</div>
</div>
}